import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, t, ...rest }) => {
	const columns = [
		{
			header: t('DocumentForm_Name'),
			accessor: 'name',
			cell: (name, row) => row.document ? <a target='blank' href={row.document.url}>{name}</a> : <span>{name}</span>,
			sortable: true
		},
		{
			header: t('DocumentForm_Category'),
			accessor: 'documentCategory',
			cell: (documentCategory) => (documentCategory.id > 0) && documentCategory.name,
			sortable: true
		},
		{
			header: t('Common_Created'),
			accessor: 'created',
			sortable: true,
			cell: created => ui.formatDateTime(created)
		},
		{
			header: t('Common_Modified'),
			accessor: 'modified',
			sortable: true,
			cell: modified => ui.formatDateTime(modified)
		},
		{
			header: t('DocumentForm_IsOnline'),
			accessor: 'isOnline',
			sortable: true,
			cell: (isOnline) => ui.formatBoolean(isOnline)
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: id => <Link to={`/documentForms/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={isReadonly ? faEye : faEdit} /> {t(isReadonly ? 'Common_View' : 'Common_Edit')}</Link>
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/documentForms/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);